import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Building2, Mic2 } from "lucide-react";

export default function ManagedView() {
  const nav = useNavigate();
  const [labels, setLabels] = useState([]);
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/labels").then((r) => setLabels(r.data));
    api.get("/artists").then((r) => setArtists(r.data));
  }, []);

  return (
    <div className="space-y-8" data-testid="managed-view-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">My Roster</h1>
        <p className="mt-1 text-muted-foreground">Labels and artists mapped to you by the Super Admin.</p>
      </div>

      <Card className="overflow-hidden" data-testid="managed-labels-card">
        <div className="flex items-center gap-2 border-b border-border p-4">
          <Building2 className="h-5 w-5 text-primary" />
          <h3 className="font-heading text-lg font-semibold">Mapped Labels ({labels.length})</h3>
        </div>
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Contact</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {labels.length === 0 && <TableRow><TableCell colSpan={3} className="py-8 text-center text-muted-foreground">No labels mapped to you.</TableCell></TableRow>}
            {labels.map((l) => (
              <TableRow key={l.id} className="cursor-pointer hover:bg-accent" onClick={() => nav(`/roster/label/${l.id}`)} data-testid={`managed-label-${l.id}`}>
                <TableCell className="font-medium">{l.name}</TableCell>
                <TableCell className="text-muted-foreground">{l.contact_email || "—"}</TableCell>
                <TableCell>{l.status || "approved"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      <Card className="overflow-hidden" data-testid="managed-artists-card">
        <div className="flex items-center gap-2 border-b border-border p-4">
          <Mic2 className="h-5 w-5 text-primary" />
          <h3 className="font-heading text-lg font-semibold">Mapped Artists ({artists.length})</h3>
        </div>
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Bio</TableHead></TableRow></TableHeader>
          <TableBody>
            {artists.length === 0 && <TableRow><TableCell colSpan={2} className="py-8 text-center text-muted-foreground">No artists mapped to you.</TableCell></TableRow>}
            {artists.map((a) => (
              <TableRow key={a.id} className="cursor-pointer hover:bg-accent" onClick={() => nav(`/roster/artist/${a.id}`)} data-testid={`managed-artist-${a.id}`}>
                <TableCell className="font-medium">{a.name}</TableCell>
                <TableCell className="text-muted-foreground">{a.bio || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
